export default "__VITE_ASSET__CXFnOAgL__"